export const progressbarWorker = () => {
    let timer;
    // eslint-disable-next-line no-restricted-globals
    self.onmessage = function (message) {
        if (message && message.data && message.data.msg === 'start-progress') {
            timer = setInterval(() => {
                postMessage('setCountProgress-call');
            }, 1000);
        }
        if (message && message.data && message.data.msg === 'clear-timeout') {
            clearInterval(timer);
        }
    };
};